module.exports = __webpack_public_path__ + "static-portal/img/embellish.621710a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome/embellish.png
// module id = 5vAm
// module chunks = 4